import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from "react-router-dom"
import "./FoodItem.css"
import { useDispatch, useSelector } from 'react-redux'
import { updateFoodQuantity } from '../../redux/actions/restaurantItemDetailsAction'
import { addToCart } from '../../redux/actions/cartActions'
import ReusableModal from '../ReusableModal/ReusableModal'

function FoodItem({ foodItem }) {

    const dispatch = useDispatch()

    const [show, setShow] = useState(false);

    const darkModeState = useSelector(state => state.darkModeReducer.isDarkMode)

    const store = useSelector(state => state.restaurantsDetailReducer.restaurantDetails);
    const cartState = useSelector(state => {
        return state.cartReducer.cart
    })

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const onUpdateQuantity = (type) => {
        let updatedFoodItems = store["food_items"]
        updatedFoodItems.forEach(item => {
            if (item.id == foodItem.id) {
                switch (type) {
                    case "ADD":
                        item.quantity = item.quantity + 1
                        break;
                    case "MINUS":
                        item.quantity = item.quantity != 1 ? item.quantity - 1 : 1
                        break;
                }
            }
        })
        dispatch(updateFoodQuantity(updatedFoodItems))
    }

    const onClickAdd = () => {
        let updatedCartList = cartState;

        /* Updating quanity if record already exists.  */

        let existingItemInCart = updatedCartList.find(item => item.id == foodItem.id)
        updatedCartList.forEach(item => {
            if (item.id == foodItem.id) {
                item.quantity = item.quantity + foodItem.quantity
            }
        })

        /* Adding into cart if food item not exists. */
        if (!existingItemInCart) {
            updatedCartList.push(foodItem)
        }

        dispatch(addToCart(updatedCartList))


        /* Clearing Qunatity after adding into cart */

        // let updatedFoodItems = store["food_items"]
        // updatedCartList.forEach(item => {
        //     if (item.id == foodItem.id) {
        //         item.quantity = 1
        //     }
        // })

        // dispatch(updateFoodQuantity(updatedCartList))
        
        handleShow(true)
    }

    let details = {
        title: "Success",
        body: "Woohoo, your item is added into cart!",
        submitButton: "Go to Cart"
    }

    return (
        <div className='food-item'>
            <ReusableModal show={show} handleClose={handleClose} handleShow={handleShow} details = {details}/>
            <div>
                <img className='restaurant-item-image' src={foodItem.image_url} />
            </div>
            <div className='restaurant-details'>
                <p style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='restaurant-name'>{foodItem.name}</p>
                <p className='restaurant-second-text'>₹ {foodItem.cost.toFixed(2)}</p>
                <div className='d-flex'>
                    <i className="fa-regular fa-star restaurant-rating"></i>
                    <p className="restaurant-item-rating-text" style={{ color:  darkModeState ? '#FFF6EE': '#101720', margin: 0 }}>{foodItem.rating.toFixed(1)}</p>
                </div>
                <div className='d-flex align-items-center'>
                    <button style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='btn plus-minus-button' onClick={() => onUpdateQuantity("MINUS")}>-</button>
                    <span className='ms-2 me-2'>{foodItem.quantity}</span>
                    <button style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='btn plus-minus-button me-3' onClick={() => onUpdateQuantity("ADD")}>+</button>
                    <button className='btn btn-success food-item-button' onClick={onClickAdd}>Add</button>
                </div>
            </div>
        </div>
    )
}

export default FoodItem